var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// components/LanguageProvider.tsx
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import i18next from 'i18next';
import moment from 'moment';
import 'moment/locale/fr';
import { Suspense, useEffect } from 'react';
import { changeYupLocale } from '../../../config/yup';
import { useUserSessionAPI } from '../../app/selectors';
import { FallbackComponent } from '../fallback';
export var I18nWrapper = function (_a) {
    var children = _a.children;
    var data = useUserSessionAPI()[0].data;
    var language = data === null || data === void 0 ? void 0 : data.language;
    useEffect(function () {
        if (!language)
            return;
        void i18next.changeLanguage(language).then(function (t) {
            document.title = t('page.title', { ns: 'translation' });
        });
        moment.locale(language);
        changeYupLocale(language);
    }, [language]);
    return (_jsx(LocalizationProvider, __assign({ dateAdapter: AdapterMoment, adapterLocale: language }, { children: _jsx(Suspense, __assign({ fallback: _jsx(FallbackComponent, { requesting: true }) }, { children: children })) })));
};
